/**************************************************
 * Nombre:       BotonPagos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Card, Grid, Typography} from "@mui/material";
import {createRef, useEffect, useState} from "react";
import btn from '../Recursos/btn_transparente.svg'
import {formatoMoneda} from "../Utilidades/formatoMoneda";
import {CreditCard, TaskAlt} from "@mui/icons-material";

const BotonPagos = ({valor = 0, idPedido, descripcion = 'Order to By Sarasty', cobro = false}) => {
    const hiddenFileInput = createRef(null);


    const key = "812f2db392b977547203644727fa5d0d"

    useEffect(() => {


        const script = document.createElement("script");
        script.src = "https://checkout.epayco.co/checkout.js";
        script.async = true;

        document.body.appendChild(script);


        return () => {
            document.body.removeChild(script);
        };




    }, [valor]);
    return (
        <>


            <form>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                >

                    <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'center', zIndex: 2}}>
                        <script
                            ref={hiddenFileInput}
                            src="https://checkout.epayco.co/checkout.js"
                            className="epayco-button"
                            data-epayco-key={key}
                            data-epayco-amount={valor}
                            data-epayco-name={idPedido}
                            data-epayco-description={descripcion}
                            data-epayco-currency="usd"
                            data-epayco-country="co"
                            data-epayco-lang={"en"}
                            data-epayco-extra1={idPedido}
                            data-epayco-extra2={cobro ? "Cobro" : ''}
                            //data-epayco-extra3={"getFechaCompleto(cita.startAt)"}
                            //data-epayco-extra4={"getHora(cita.startAt)"}
                            data-epayco-test="false"
                            data-epayco-autoclick='false'
                            data-epayco-external="false"
                            // envia a direcciones https unicamente
                            data-epayco-response={"https://sarasty.com/home"}
                            data-epayco-button={btn}
                        >

                        </script>

                    </Grid>


                    <Grid item container lg={12} sm={12} xs={12}
                          sx={{justifyContent: 'center', zIndex: 1, marginTop: -6}}>
                        <Button color={'primary'}
                                startIcon={<CreditCard/>}>{`Pay With Card: ${formatoMoneda(valor, 2)} USD`}</Button>
                    </Grid>

                </Grid>


            </form>


        </>

    );
};

export default BotonPagos;